import { FormsSubmissions } from '@frontend/api';

export const useShowReadUnreadStatus = (category: FormsSubmissions.Types.SubmissionLists): boolean => {
  const categoriesToInclude: FormsSubmissions.Types.SubmissionLists[] = ['inbox'];

  return categoriesToInclude.includes(category);
};
